import { render, staticRenderFns } from "./MessageHandler.vue?vue&type=template&id=12b670e9"
import script from "./MessageHandler.vue?vue&type=script&lang=ts"
export * from "./MessageHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports